import React from "react";
import logger from "logger";
import { doTask } from "Utils/TaskService";
import { showDialog } from "DialogProvider";
//import RunButton from "TaskDialogCommon/RunButton";
import { DialogButton } from "Common/DialogButton";

export default function({
  taskname,
  taskConfig,
  label,
  colspan,
  validate,
  test,
}) {
  return (
    <div style={{ padding: "7px" }}>
      <div>
        <DialogButton
          onClick={(event) => {
            event.preventDefault();
            if (test) {
              logger.log("RunButton Clicked ", taskname, taskConfig);
              return;
            }
            if (validate) {
              if (validate()) {
                doTask(taskname, taskConfig);
                showDialog(null);
              }
            } else {
              doTask(taskname, taskConfig);
            }
          }}
          label={label}
        />
      </div>
    </div>
  );
}
